import { compose } from 'recompose'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import withRedirect from 'components/common/hoc/withRedirect'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import { showVehicleMergeModal, mergeApiDecorator } from 'actions/mergeVehicle'
import { FORM_NAME, PASSWORD_PROPERTY } from './constants'
import getInitialValues from 'helpers/getInitialValues'
import { isFieldActive } from 'selectors/redux-form'
import { getLocationState } from 'selectors/getPageLocation'
import validate from './validatorConfig'
import form from './form'
import { googleAnalyticEmailAddressFill } from 'actions/googleAnalytic'

const selector = formValueSelector(FORM_NAME)

const mapStateToProps = state => {
  const initialValues = getInitialValues(form)
  const {
    profilePopulationData: {
      email: profilePopulationEmail = '',
      primaryPhone: profilePopulationPrimaryPhone = '',
      firstName: profilePopulationFirstName = '',
      lastName: profilePopulationLastName = ''
    } = {},
    profilePopulationData = {}
  } = (getLocationState(state) || {})
  return {
    profilePopulationData,
    initialValues: {
      ...initialValues,
      [form.email.name]: profilePopulationEmail,
      [form.primaryPhone.name]: profilePopulationPrimaryPhone,
      [form.firstName.name]: profilePopulationFirstName,
      [form.lastName.name]: profilePopulationLastName
    }
  }
}

export default compose(
  withRedirect,
  connect(mapStateToProps),
  reduxForm({ form: FORM_NAME, validate }),
  connect(
    state => ({
      values: selector(
        state,
        form.firstName.name,
        form.lastName.name,
        form.primaryPhone.name,
        form.email.name,
        form.password.name,
        form.confirmPassword.name,
        form.keepInContact.name,
        form.termsAgreement.name
      ),
      isPasswordFieldActive: isFieldActive(FORM_NAME, PASSWORD_PROPERTY)(state)
    }),
    { showVehicleMergeModal, mergeApiDecorator, googleAnalyticEmailAddressFill }
  )
)
